import { formatDateTime } from '@/utils/commonFormats';

export const parseTimestamp = (value?: Date | string | null): Date | undefined => {
  if (!value) {
    return undefined;
  }

  const parsed = value instanceof Date ? value : new Date(value);

  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
};

const formatTimestamp = (value?: Date | string | null): string | undefined => {
  const parsed = parseTimestamp(value);

  return parsed ? formatDateTime(parsed, { hideYear: true, includeTimeZone: true }) : undefined;
};

export default formatTimestamp;
